const form8 = {
  formId8: "new-user-form8",
  formField8: {
    endow: {
      name: "endow",
      label: "Ưu đãi cùng/ khác địa bàn với nơi có trụ sở chính:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn ưu đãi cùng/ khác địa bàn với nơi có trụ sở chính",
    },
    departmentLevel: {
      name: "departmentLevel",
      label: "Cơ quan thuế cấp Cục:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn cơ quan thuế cấp Cục",
    },
    subordinateToTheDepartment: {
      name: "subordinateToTheDepartment",
      label: "Cơ quan thuế cấp chi Cục:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn cơ quan thuế cấp chi Cục",
    },
    city: {
      name: "city",
      label: "[09C] Tỉnh/ thành phố:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn tỉnh/ thành phố",
    },
    district: {
      name: "district",
      label: "[09B] Quận/ huyện:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn quận/ huyện",
    },
    commune: {
      name: "commune",
      label: "[09C] Xã/ phường:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn xã/ phường",
    },
    isFemale: {
      name: "isFemale",
      label: "Doanh nghiệp hoạt động sản xuất, xây dựng, vận tải sử dụng nhiều lao động nữ:",
      type: "text",
    },
    sumFemale: {
      name: "sumFemale",
      label: "Tổng số lao động sử dụng thường xuyên trong kỳ tính thuế:",
      type: "numbner",
      placeholder: "",
      errorMsg: "Vui lòng nhập tổng số lao động nữ sử dụng thường xuyên trong kỳ tính thuế",
    },
    confirmFemale: {
      name: "confirmFemale",
      label: "Xác nhận của cơ quan quản lý có thẩm quyền về tổng số lao động nữ mà doanh nghiệp đang sử dụng (nếu có): Số:",
      type: "text",
      placeholder: "",
    },
    dateConfirmFemale: {
      name: "dateConfirmFemale",
      label: "Ngày:",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày",
    },

    isMinority: {
      name: "isMinority",
      label: "Doanh nghiệp sử dụng lao động là người dân tộc thiểu số:",
      type: "text",
    },
    sumMinority: {
      name: "sumMinority",
      label: "Tổng số lao động sử dụng thường xuyên trong kỳ tính thuế:",
      type: "numbner",
      placeholder: "",
      errorMsg: "Vui lòng nhập tổng số lao động nữ sử dụng thường xuyên trong kỳ tính thuế",
    },
    confirmMinority: {
      name: "confirmMinority",
      label: "Xác nhận của cơ quan quản lý có thẩm quyền về tổng số lao động là người dân tộc thiểu số mà doanh nghiệp đang sử dụng (nếu có): Số:",
      type: "text",
      placeholder: "",
    },
    dateConfirmMinority: {
      name: "dateConfirmMinority",
      label: "Ngày:",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày",
    },

    taxReductionFemale: {
      name: "taxReductionFemale",
      label: "Giảm thuế thu nhập doanh nghiệp (TNDN) tương ứng với mức chi lao động nữ:",
      type: "text",
    },
    taxReductionMinority: {
      name: "taxReductionMinority",
      label: "Giảm thuế thu nhập doanh nghiệp tương ứng với mức lao động là người dân tộc thiểu số:",
      type: "text",
    },
  },
};

export default form8;
